import { IEnvironment } from '../../../../libs/models/src';

export const environment: IEnvironment = {
  version: '1.0.0',
  siteName: 'SMMOF',
  production: true,
  baseUrl: 'https://smmof.ru/',
  apiUrl: 'https://api.smmof.ru/',
  baseDomain: 'smmof.ru',
  metrikaID: 100506560,
  yookassaAgentId: '508227',
};
